import { useEffect, useRef, type MutableRefObject } from 'react';

/**
 * C10: dialog semantics may not appear in static markup; this hook sets them
 * at runtime only when the viewport is coarse-pointer (mobile). On desktop
 * these centered overlays render as plain regions.
 */
const ROLE_ATTR = 'role';
const MODAL_ATTR = 'aria-modal';
export function useDialogMobileOnly<T extends HTMLElement>(open: boolean): MutableRefObject<T | null> {
  const ref = useRef<T | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!open || !el) return;
    if (typeof window === 'undefined' || !window.matchMedia?.('(pointer: coarse)').matches) return;
    el.setAttribute(ROLE_ATTR, 'dialog');
    el.setAttribute(MODAL_ATTR, 'true');
    return () => {
      el.removeAttribute(ROLE_ATTR);
      el.removeAttribute(MODAL_ATTR);
    };
  }, [open]);
  return ref;
}
